import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
	selector: 'app-tourism-events-history',
	templateUrl: './tourism-events-history.component.html',
	styleUrls: ['./tourism-events-history.component.css'],
})
export class TourismEventsHistoryComponent implements OnInit {
	id: string;

	constructor(private readonly route: ActivatedRoute) {}

	ngOnInit(): void {
		if (!this.route.snapshot.params['id']) {
			return;
		}
		this.id = this.route.snapshot.params['id'];
	}
}
